import Vue from "vue";

const state = {
  countries: []
};

const getters = {};

const actions = {
  GET_COUNTRIES: function({ commit }) {
    Vue.prototype.$axios.get("/countries").then(res => {
      commit("SET_COUNTRIES", res.data.countries);
    });
  }
};

const mutations = {
  SET_COUNTRIES(state, payload) {
    state.countries = payload;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
